import store from './store'
import Vue from 'vue'
import { Notification } from 'element-ui'

let websock = null
let lockReconnect = false// 避免ws重复连接
let timeoutObj = null
let serverTimeoutObj = null
let heartTimeout = 600000// 心跳检测时间6m
let resetLinkTimeout = 10000// 重连时间10s
export async function initWebSocket () {
  let url
  try {
    let user = store.state.user
    url = Vue.prototype.wsPath + user.userId + '/' + Vue.prototype.siteId
    // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
    websock = new WebSocket(url)
    websock.onopen = websocketonopen
    websock.onerror = websocketonerror
    websock.onmessage = websocketonmessage
    websock.onclose = websocketclose
  } catch (e) {
    reconnect(url)
  }
}

// 重新连接，没连接上会一直重连，设置10s延迟避免请求过多
function reconnect (url) {
  if (lockReconnect) return
  lockReconnect = true
  setTimeout(() => {
    initWebSocket(url)
    lockReconnect = false
  }, resetLinkTimeout)
}

// ws关闭，出发重新连接方法，谷歌浏览器会主动触发（即服务端关闭时浏览器会主动触发此事件，但有些浏览器可能不会主动触发）
function websocketclose (e) {
  console.log('connection closed (' + e.code + ')')
  let user = store.state.user
  reconnect(Vue.prototype.wsPath + user.userId + '/' + Vue.prototype.siteId)
}

// ws连接错误
function websocketonerror (e) {
  console.log('WebSocket连接发生错误')
  let user = store.state.user
  reconnect(Vue.prototype.wsPath + user.userId + '/' + Vue.prototype.siteId)
}

// ws连接成功
function websocketonopen () {
  heartReset()// 清除定时器
  heartStart()// 启动心跳检测
  console.log('WebSocket连接成功')
}

// ws接收消息
function websocketonmessage (e) {
  let msg = JSON.parse(e.data)
  if (msg.msg) {
    Notification({
      title: '您有一条新的消息',
      type: 'success',
      message: msg.msg,
      duration: 0
    })
  }

  heartReset()
  heartStart()// 获取到消息说明连接正常，启动心跳检测
}

function heartReset () {
  clearTimeout(timeoutObj)
  clearTimeout(serverTimeoutObj)
}

// 启动心跳检测
function heartStart () {
  let user = store.state.user
  timeoutObj = setTimeout(() => {
    websock.send(JSON.stringify({
      authorId: user.userId,
      siteId: Vue.prototype.siteId
    }))
    // 此处触发onclose方法，执行重连操作，如果超过时间没有重连说明服务器已经断开连接
    serverTimeoutObj = setTimeout(() => {
      websock.close()
    }, heartTimeout)
  }, heartTimeout)
}
// 关闭websocket
export function clearWebSocket () {
  websock.close()
  heartReset()
}



// WEBPACK FOOTER //
// ./src/socket.js